<template>
  <div class="add_warp">
    <div>
      <div class="courseInfo">课程信息</div>

      <el-form 
        :model="formData" 
        :rules="formRules"
        ref="baseFormRef" 
        label-position="right" 
        label-width="120px" 
        style="padding-left: 30px;"
      >

        <el-form-item label="选择课程" prop="product_id">
          <div style="display: flex;align-items: center;">
            <addCourseSelect 
              v-model="formData.product_id"
              :httpRequest="getClassRequest"
              style="width: 240px;"
              :selectProps="{
                label: 'title',
                value: 'id',
                disable:'disabled'
              }"
              :filterable="true"
              :disable="!!class_id"
            >
            </addCourseSelect>
            <div style="font-size:12px;line-height: 20px; margin-left:10px;">
              <div style="color:#666;">
                抖店课程需要和您已创建的抖音小程序课程（必须已上架）进行关联，抖店下单小程序学习
              </div>
              <div style="color:red;">
                注意：抖店商品与小程序课程是多对一关系
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="课程分类" prop="cat_id">
          <el-cascader
            :key="class_id ? JSON.stringify(formData.cat_id) : 'type-box'"
            v-model="formData.cat_id"
            style="width: 240px;"
            :options="typeOptions"
            :props="{
              label: 'name',
              value: 'id',
              lazy: true,
              lazyLoad: getCateLazyRequest
            }"
            @change="typeChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item v-if="formData.cat_id[0]==20342" label="出版社名称" prop="pressName">
          <el-input 
            v-model="formData.pressName"
            maxlength="30" 
            style="width: 240px;"
            placeholder="出版社名称限30字以内"
          >
          </el-input>
        </el-form-item>

        <el-form-item v-if="formData.cat_id[0]==20342" label="ISBN编码" prop="isbn">
          <el-input 
            v-model="formData.isbn"
            maxlength="30" 
            style="width: 240px;"
            placeholder="ISBN编码限30字以内"
          >
          </el-input>
          <el-tooltip content="公共 ISBN 编码存在多人重复使用的情况，这可能会对您的课程审核造成影响，导致其无法顺利通过。" placement="top">
            <el-button style="margin-left: 10px;" type="primary" @click="setTestIsbn">
              使用平台公有ISBN编码
              <i class="el-icon-question" style="margin-left: 5px;"></i>
            </el-button>
          </el-tooltip>
          
        </el-form-item>
        <!-- userInfo.doushop_is_self 1自营 2服务商 -->
        <el-form-item v-if="userInfo.doushop_is_self==2" label="商品类型" prop="is_virtual">
        <!-- <el-form-item label="商品类型" prop="is_virtual"> -->
          <el-radio-group v-model="formData.is_virtual">
            <el-radio v-for="item in productTypeObj.list" :key="item.id" :disabled="item.disable" :label="item.id">{{ item.name }}</el-radio>
          </el-radio-group>
          <div style="color: #f41414;font-size: 14px;">注意：教育培训类目虚拟商品不支持ios用户支付</div>
        </el-form-item>

        <!-- 根据分类填的其他属性 -->
        <addOtherInfo ref="addOtherInfoRef" :nowType="otherInfoType" v-model="otherInfo" :dataList="otherInfoList"></addOtherInfo>

        <el-form-item label="课程标题" prop="title">
          <el-input 
            v-model="formData.title"
            maxlength="30" 
            style="width: 240px;"
            placeholder="课程标题限30字以内"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="课程售价" prop="price">
          <div style="display: flex;align-items: center;">
            <el-input 
              v-model="formData.price"
              style="width: 240px;"
              placeholder="支持小数点后两位"
              type="number"
            >
            </el-input>
            <div style="color: #666;font-size:12px;line-height: 20px; margin-left:10px;">
                元
            </div>
          </div>
        </el-form-item>

        <el-form-item label="库存" prop="stock">
          <div style="display: flex;align-items: center;">
            <el-input 
              v-model="formData.stock"
              style="width: 240px;"
              type="number"
              placeholder="请输入库存数量"
            >
            </el-input>
          </div>
        </el-form-item>

        <el-form-item label="轮播图" prop="images">
          <div style="font-size:12px; color:#666;">
            第一张为主图，至少上传3张最多上传5张，单张5MB以内，比例1:1至少600x600，以保证审核通过。
          </div>
          <uploadImage
            v-model="formData.images"
            :limit="5"
            :maxSize="5"
            :needCut="true"
            addText="添加主图" 
            :accept="['.jpg', '.png', '.jpeg']"
          >
          </uploadImage>
        </el-form-item>

        <el-form-item label="课程介绍" prop="image_descriptions">
          <div style="font-size:12px; color:#666;">
            单张图片需限制在10M以内
          </div>
          <uploadImage
            v-model="formData.image_descriptions"
            :limit="50"
            :maxSize="10"
            :accept="['.jpg', '.png', '.jpeg']"
          >

          </uploadImage>
        </el-form-item>

      </el-form>
    </div>
    <div class="from_item_con">
      <el-button type="primary" @click="submitForm()">提交审核</el-button>
    </div>
  </div>
</template>

<script>
import formCustom from "../../../components/useTable/customForm";
import addCourseSelect from "../../../components/virtualizedSelect/addCourseSelect.vue";
import uploadImage from "./components/uploadImg/uploadImg.vue";
import searchCascader from "../../../components/searchCascader/searchCascader.vue";
import addOtherInfo from "./components/addOtherInfo/addOtherInfo.vue"
import { formRules } from './helper/data'

import { mapActions, mapState } from "vuex";

export default {
  components: {
    formCustom,
    addCourseSelect,
    uploadImage,
    searchCascader,
    addOtherInfo
  },
  data() {
    return {
      formData: { // 表单信息
        product_id: "",
        cat_id: [],
        is_virtual: 2, // 商品类型 (是否为虚拟商品: 1是 2否)
        title: "",
        price: "", // 课程价格（元）
        stock: 0, // 库存
        image_descriptions: [], // 详情图
        images: [], // 主图
        pressName:"",//出版社名称
        isbn:"",//isbn编码
      },
      formRules: formRules, // 表单校验
      class_id: null, // 课程id(编辑需要传)
      otherInfo: {}, // 分类其他属性
      otherInfoList: [],//其他属性列表
      otherInfoType: 'create', // 其他属性列表状态
      productTypeObj: { // 商品类型相关
        list: [
          {name: '普通商品', id: 2, disable: false},
          {name: '虚拟商品', id: 1, disable: false}
        ]
      },
      typeOptions: [],
      isbnTest:[
        {
          isbn: '9787203069676',
          pressName: '山西人民出版社'
        },
        {
          isbn: '9787203069677',
          pressName: '平凡的世界'
        },
        {
          isbn: '9787203069678',
          pressName: '解忧杂货店'
        },
      ]
    };
  },
  created() {
    this.class_id = this.$route.params.id ? this.$route.params.id : null;
    // console.log('hhhh-class_id:',this.class_id)
    if (this.class_id) {
      this.otherInfoType = 'edit'
      this.getEditClassData();
    }
  },
  computed: {
    ...mapState('login',  ['userInfo']),
  },
  methods: {
    ...mapActions("wxVideo", [
      "videoClassProduct",
    ]),
    ...mapActions("ddApis", [
      "getDdClassCateAPI", 
      "getDdClassCateTopAPI", 
      "getCatePropertiesAPI", 
      "createEditDdGoodsAPI", 
      "getDdGoodsDetailAPI",
      "getDdCanSelectClassListAPI"
    ]),
    setTestIsbn(){
      let randomNumber = Math.floor(Math.random() * this.isbnTest.length);
      this.formData.isbn = this.isbnTest[randomNumber].isbn
      this.formData.pressName = this.isbnTest[randomNumber].pressName

    },
    // 获取课程
    async getClassRequest(params) {
      let res = await this.videoClassProduct(params);
      // let res = await this.getDdCanSelectClassListAPI({
      //   ...params,
      //   single: -1,
      //   status: 1,
      //   is_dy_sale: ''
      // })
      let data = {
        total: res.count,
        data: res.data,
      };
      this.formData.product_id = this.formData.product_id
        ? this.formData.product_id
        : data?.data[0]?.product_id;
      return data;
    },
    typeChange(e){
      // this.handleProductTypeObj()
    },
    // handleProductTypeObj(isEditShow=false){
    //   let productTypeObj = {}
    //   if(this.formData.cat_id.length){
    //     const obj = {
    //       '20342': { // 知识服务/读书卡 (自营)
    //         show: true,
    //         list: [ {name: '普通商品', id: 0, disable: true}, {name: '虚拟商品', id: 1, disable: false} ],
    //         default: 1
    //       },
    //       '20077': { // 教育培训 (服务商)
    //         show: true,
    //         list: [ {name: '普通商品', id: 0, disable: false}, {name: '虚拟商品', id: 1, disable: false} ],
    //         default: 0
    //       },
    //     }
    //     if(!isEditShow){
    //       this.formData.is_virtual = obj[this.formData.cat_id[0]].default
    //     }
    //     productTypeObj = obj[this.formData.cat_id[0]]
    //   }else{
    //     productTypeObj = {
    //       show: false,
    //       list: []
    //     }
    //   }
    //   this.productTypeObj = productTypeObj
    // },
    // 分类懒加载
    async getCateLazyRequest (node, resolve) {
      const { level } = node;
      let res = [];
      if (level == 0) {
        res = await this.getTopCategory();
      } else {
        res = await this.getCategory({ parent_id: node.value });
      }
      res = res.map((item) => {
        // console.log('res.map-item:', item)
        return {
          ...item,
          // leaf: level >= 2,
          leaf: item.is_leaf
        };
      });
      resolve(res);
    },
    // 获取顶级分类
    async getTopCategory(){
      let res = await this.getDdClassCateTopAPI()
      res = res.map(item=> {
        return {
          ...item, 
          id: parseInt(item.id)
        }
      })
      // console.log('getCategory-res:',res)
      return res;
    },
    // 获取课程分类
    async getCategory(params) {
      let res = await this.getDdClassCateAPI({ ...params })
      // console.log('getCategory-res:',res)
      return res;
    },
    toObject(pairs,type) {
      return pairs.reduce(
        (obj, item, cindex) => (
          (obj["attr_key" + cindex] = type==1?item.attr_value:""), obj
        ),
        {}
      );
    },
    async submitForm(type) {
      if(!await this.validateBaseFormFn()) return // 校验基本信息
      if(!this.$refs.addOtherInfoRef.validateFormFn()) return // 校验分类其他属性
      let params = { ...this.formData };
      // params.second_cate_id = params.cat_id[0] || '' // 一级分类ID
      params.category_array = [...params.cat_id] // 多级分类，数组

      let otherInfoDeepCopy = JSON.parse(JSON.stringify(this.otherInfo))
      for(let k in otherInfoDeepCopy){
        otherInfoDeepCopy[k].forEach(item=>{
          item.value = Number(item.value)
        })
      }
      params.property = otherInfoDeepCopy // 里面的value都转成了number型

      delete params.cat_id
      // console.log('submitForm-params:',params)
      // return
      if(this.formData.cat_id[0]==20342){// 分类知识服务/读书卡 的话需要 出版社名称  isbn编码
        params.property[1618] = [{
            diy_type: 0,//写死的值 抖店规定
            name: params.isbn,
            value: 0,//写死的值 抖店规定
          }]
          params.property[855] = [{
            diy_type: 1,//写死的值 抖店规定
            name: params.pressName,
            value: 0,//写死的值 抖店规定
          }]
          delete params.isbn
          delete params.pressName
        }else{
          delete params.property[1618]
          params.property[855] = [{
            diy_type: 1,//写死的值 抖店规定
            name: '豆包知道',
            value: 0,//写死的值 抖店规定
          }]
        }
        // 处理课程跟踪辅导天数(5592) 和 课程有效期(5588) 单位
        if (params.property[5588] && !/月$/.test(params.property[5588]?.[0]?.name)) {
          params.property[5588][0].name = `${params.property[5588][0].name}月`;
        }

        if (params.property[5592]&&!/天$/.test(params.property[5592]?.[0]?.name)) {
          params.property[5592][0].name = `${params.property[5592][0].name}天`;
        }
      
      console.log(params, 'paramsparams');
      if (this.class_id) {
        await this.createEditDdGoodsAPI({ ...params, id: this.class_id })
      } else {
        await this.createEditDdGoodsAPI( params )
      }
      this.$message({
        type: "success",
        message: "提交成功",
      });
      this.$router.go(-1);
    },
    // 表单校验 返回true通过校验
    validateBaseFormFn(){
      return new Promise((resolve)=>{
        this.$refs.baseFormRef.validate((a, b)=>{
          if(a){
            resolve(true)
          }else{
            this.$message.error('请先完善课程信息')
            resolve(false)
          }
        })
      })
    },
    // 编辑时-获取回显数据
    async getEditClassData() {
      let res = await this.getDdGoodsDetailAPI({ id: this.class_id })
      console.log('getEditClassData-res:',res)
      if(res.category_array && res.category_array[0]==20342){// 分类知识服务/读书卡 的话需要 出版社名称  isbn编码
          res.isbn = (res.property[1618]&&res.property[1618][0].name) || ''
          res.pressName = (res.property[855]&&res.property[855][0].name) || ''
        }

      // res.image_descriptions = JSON.parse(res.image_descriptions)
      // res.images = JSON.parse(res.images)
      // res.price = numberTransform(res.price/100)
      // console.log('getEditClassData-res:',res)
      if(typeof res.property == 'string') res.property = JSON.parse(res.property)
      for(let k in res.property){
        res.property[k].forEach(item=>{
          if(item.value!=0) item.value+='' // 非0得value，转成字符串
        })
      }
      let res2 = {...res}
      res2.cat_id = res2.category_array.map(item=>Number(item))
      delete res2.category_array
      for (const key in this.formData) {
        if (res2[key]) {
          this.formData[key] = res2[key];
        }
      }
      console.log('hhhh-formData:',this.formData)
      this.otherInfo = res2.property
      // this.handleProductTypeObj(true)
    },
    async getCatePropertiesFn(id){
      if(!id) return
      let res = await this.getCatePropertiesAPI({
        cat_id: id
      })
      // console.log("getCatePropertiesFn-res:", res)
      this.otherInfoList = res
    }
  },
  watch: {
    "formData.cat_id":{
      immediate: true,
      handler(news) {
        if (news.length) {
          console.log('formData.cat_id:',news)
          this.getCatePropertiesFn(news[news.length-1])
        }
      }
    },
  },
};
</script>

<style lang="less">
.courseInfo {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}
.from_item_con {
  width: 100%;
  display: flex;
  justify-content: center;
}
.add_warp {
  width: 100%;
  position: relative;
}
</style>